module.exports = __webpack_public_path__ + "img/logotanzhiw.a476a905.png";